export const LocationProgressBar = ({completed, total}) => {
  const percentage = total > 0 ? (completed / total) * 100 : 0;

  return (
    <div className='baseline-location-progress-container'>
      <div className='baseline-location-progress-bar'>
        <div
          className='baseline-location-progress-fill'
          style={{width: `${Math.min(percentage, 100)}%`}}
        />
      </div>
      <span className='baseline-location-progress-text'>
        {completed}/{total} ({percentage.toFixed(1)}%)
      </span>
    </div>
  );
};
